import { featureScopeOptions } from '../../react-query/feature-availability/constants'

export const featureSlugs = {
  BULK_EDIT: 'BULK_EDIT',
  COPY_PROJECT: 'COPY_PROJECT',
  DATASETS: 'DATASETS',
  ORGANIZATION_NAMES: 'ORGANIZATION_NAMES',
  PIN_FIELDS: 'PIN_FIELDS',
  REPORT_TEMPLATE: 'REPORT_TEMPLATE',
  UNLIMITED_REPORT_STORAGE: 'UNLIMITED_REPORT_STORAGE',
  PLAN_EXPORT: 'PLAN_EXPORT',
  TASKS: 'TASKS'
}

export const features = Object.values(featureSlugs)

// Which organisation's subscription answers for each feature by default. A call
// site can override it — the project menu asks at OWN_ORGANISATION scope so a
// list of the user's own projects costs one request instead of one per row —
// which is why this is the default and not the feature's fixed scope.
export const FEATURE_DEFAULT_SCOPE = {
  BULK_EDIT: featureScopeOptions.PROJECT_ORGANISATION,
  COPY_PROJECT: featureScopeOptions.OWN_ORGANISATION,
  DATASETS: featureScopeOptions.PROJECT_ORGANISATION,
  ORGANIZATION_NAMES: featureScopeOptions.OWN_ORGANISATION,
  PIN_FIELDS: featureScopeOptions.PROJECT_ORGANISATION,
  PLAN_EXPORT: featureScopeOptions.PROJECT_ORGANISATION,
  REPORT_TEMPLATE: featureScopeOptions.OWN_ORGANISATION,
  UNLIMITED_REPORT_STORAGE: featureScopeOptions.PROJECT_ORGANISATION,
  // PROJECT_ORGANISATION, not OWN_ORGANISATION: the view keeps the Tasks tab in
  // external Combo+ projects, and only a per-project answer can tell those
  // apart from the user's own Pocket project.
  TASKS: featureScopeOptions.PROJECT_ORGANISATION
}

// Where a locked feature explains itself, which is a property of the call site
// and not of the slug: the same slug shows a panel inside the pin details
// accordion and a dialog in the side menu. PANEL means the consumer renders
// `FeatureUnavailablePanel` itself, so there is no dialog to open and the click
// has to stay live — the accordion still needs to toggle, and the panel's own
// "upgrade" button still needs to fire.
export const restrictionSurfaceOptions = {
  DIALOG: 'dialog',
  PANEL: 'panel'
}

// A section narrows a slug down to one surface, so the same feature can carry
// different copy in different places.
export const featureSectionOptions = {
  BULK_TASKS_CREATION: 'BULK_TASKS_CREATION',
  BULK_TASKS_EDIT: 'BULK_TASKS_EDIT',
  BULK_PINS_EDIT: 'BULK_PINS_EDIT',
  BULK_PINS_ADD_TASKS: 'BULK_PINS_ADD_TASKS',
  PIN_DETAILS_TASKS: 'PIN_DETAILS_TASKS'
}

export const featureSection = Object.values(featureSectionOptions)
